// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IdVerification } from '@interfaces/document.interfaces';
import { isBuyerIdentification } from 'src/app/utils/document-utils';

@Component({
    selector: 'app-id-unverified-modal',
    templateUrl: './id-unverified-modal.component.html',
    styleUrls: ['./id-unverified-modal.component.scss'],
})
export class IdUnverifiedModalComponent implements OnInit {
    public deal: any;
    public tenantSupportPhone: string;
    public verif: IdVerification;
    private customerType: 'buyer' | 'cobuyer';
    constructor(
        private dialogRef: MatDialogRef<IdUnverifiedModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { deal: any; idVerificationResults: IdVerification; tenantSupportPhone: string }
    ) {
        this.deal = data.deal;
        this.tenantSupportPhone = data.tenantSupportPhone;
        this.verif = data.idVerificationResults;
        this.customerType = isBuyerIdentification(this.verif.internalDocumentTypeId) ? 'buyer' : 'cobuyer';
    }

    get customerName(): string {
        const user = this.customerType === 'buyer' ? this.deal.buyer : this.deal.coBuyer;
        let name = user.firstName;
        if (user.middleName) {
            name += ` ${user.middleName}`;
        }
        name += ` ${user.lastName}`;
        return name;
    }

    get customerTitle(): string {
        return this.customerType === 'buyer' ? 'Buyer' : 'Co-Buyer';
    }

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
